import styles from "./VenuesPage.module.scss";
import {useEffect, useState} from "react";
import useAppSelector from "../../hooks/useAppSelector";
import Spinner from "../../components/Spiner/Spinner";
import {VenueService} from "../../services/venue.service";
import useAppDispatch from "../../hooks/useAppDispatch";
import {setVenues} from "../../store/venues/venuesSlice";
import VenueItem from "../../components/VenueItem/VenueItem";
import {useQuery} from "../../hooks/useQuery";
import StripeElements from "../../components/StripeElements/StripeElements";
import Check3DSecurePayment from "../../components/Check3DSecurePayment/Check3DSecurePayment";

const VenuesPage = () => {
    const query = useQuery();

    const [paymentIntentId] = useState(query.get("payment_intent_client_secret"));
    const dispatch = useAppDispatch();
    const {venues, venuesLoading} = useAppSelector(state => state.venuesSlice);

    useEffect(() => {
        getVenuesList()
    }, []);

    const getVenuesList = async () => {
        try {
            const response = await VenueService.getVenues();
            if (response.status === 200) {
                dispatch(setVenues(response.data));
            }
        } catch (e) {
        }
    }

    if (venuesLoading) {
        return (
            <div className={styles.spinnerWrapper}>
                <Spinner/>
            </div>
        )
    }

    return (
        <section className={styles.page}>
            <div className={"container"}>
                <div className={styles.wrapper}>
                    {
                        venues.map(venue => {
                                return (
                                    <VenueItem
                                        key={venue.id}
                                        venue={venue}
                                    />
                                )
                            }
                        )
                    }
                </div>
            </div>
            {
                paymentIntentId && (
                    <StripeElements>
                        <Check3DSecurePayment
                            fromUrl={"/venues"}
                            paymentIntentId={paymentIntentId}
                        />
                    </StripeElements>
                )
            }
        </section>
    )
}

export default VenuesPage;